import { appInfo } from "@/common/data"; 
export default [
    {
            path: "/00d646c5111d64ecae93f005",
            children: [
              {
                path: "/022c94115f4387ee1ff470bf",
                name: "saiqe25.gazettes",
                component: () => import("@/views/saiqe/twf/gazette/list.vue"),
                meta: {
                  title:
                    appInfo?.type == "codemsi"
                      ? "SAISSCE 2025 Gazettes"
                      : "SAIQE 2025 Gazettes",
                  authRequired: true,
                  acc: ["y15775"],
                },
              },
              {
                path: "/007a13bcf4971a12b3243025",
                name: "saiqe25.pendinggazettereq",
                component: () =>
                  import("@/views/saiqe/twf/gazette/pendingrequests.vue"),
                meta: {
                  title:
                    appInfo?.type == "codemsi"
                      ? "SAISSCE 2025 Pending Gazette Requests"
                      : "SAIQE 2025 Pending Gazette Requests",
                  authRequired: true,
                  acc: ["y72650"],
                },
              },
              {
                path: "/024d19660fd595d159c5387a",
                name: "saiqe25.uploadgazette",
                component: () => import("@/views/saiqe/twf/gazette/upload.vue"),
                meta: {
                  title:
                    appInfo?.type == "codemsi"
                      ? "Upload SAISSCE 2025 Gazette"
                      : "Upload SAIQE 2025 Gazette",
                  authRequired: true,
                  acc: ["y70304"],
                },
              },
              {
                path: "/02692090e82c3f14084c766a",
                name: "saiqe25.uploadedgazettes",
                component: () =>
                  import("@/views/saiqe/twf/gazette/uploaded-gazette.vue"),
                meta: {
                  title:
                    appInfo?.type == "codemsi"
                      ? "Uploaded SAISSCE 2025 Gazettes"
                      : "Uploaded SAIQE 2025 Gazettes",
                  authRequired: true,
                  acc: ["y10535"],
                },
              },
              {
                path: "/0253b4de823cc3ea9d25e5d6/:er?",
                name: "saiqe25.gazette",
                component: () => import("@/views/saiqe/twf/gazette/vgazette.vue"),
                meta: {
                  title:
                    appInfo?.type == "codemsi"
                      ? "Print SAISSCE Gazette"
                      : "Print SAIQE Gazette",
                  authRequired: true,
                  acc: ["y69520"],
                },
              },
            ],
          },

]